export const SET_CHARITY = "SET_CHARITY";
export const SET_COMPARISON = "SET_COMPARISON";
export const SET_PAGE = "SET_PAGE";
export const SET_YEAR = "SET_YEAR";
export const SET_BUBBLE_EXPAND = "SET_BUBBLE_EXPAND";


// WEBPACK FOOTER //
// ./src/actions/const.js